import React, { useEffect, useState, useRef } from 'react';
import { StackedColumnChart } from 'bizcharts';
import { comma } from 'utils/function';
import { Typography, Box, MenuItem, Select } from '@mui/material';
import { ApiExportExcel } from 'utils/api/export'
import DialogSubmit from 'utils/components/modal-submit';
import moment from 'moment';
import html2canvas from "html2canvas";


function ChartCustom({ title, data, color = {}, filter = {}, export_code = false, export_file = [] }) {

    const chartRef = useRef(null);
    const [fileExport, setFileExport] = useState(null);
    const [typeSubmit, setTypeSubmit] = useState('');
    const [openSubmit, setOpenSubmit] = useState(false);
    const [currentColor, setCurrentColor] = useState(color);
    const [currentData, setCurrentData] = useState(data);



    const handleOpenSubmit = (status, close) => {
        setOpenSubmit(status);
        if (close) {


            if (['EXCEL'].includes(fileExport)) {

                let status = handleExportExcel(export_code, {
                    // pid: user?.card_id,
                }, `excel-${title}`)
                if (status) {
                    // setFilterExport('null')
                    // setFilterDepartment('all')
                    // setFilterHospital('all')
                    // setFilterYear('all')

                }

            } else if (['PNG'].includes(fileExport)) {

                handleExportPNG()


            }

            setTypeSubmit('');
            setFileExport(null);
        }
    };

    const handleExportExcel = async (excel_code, filter, file_name) => {

        let result = await ApiExportExcel({
            "export_code": excel_code,
            "file_name": file_name,
            "filter": filter
        })

        if (result?.status) {

            let { file_url } = result.data

            // Create a hidden anchor element for downloading the file
            const link = document.createElement('a');
            link.href = file_url;
            link.download = ''; // Optional: specify a custom filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            return true

        } else {
            return false

        }





    }

    const handleExportPNG = () => {
        if (chartRef.current) {
            html2canvas(chartRef.current).then((canvas) => {
                const link = document.createElement("a");
                link.href = canvas.toDataURL("image/png");
                // link.download = "chart.png";
                link.download = `${title}-${moment(Date.now()).format('YYYY-MM-DD_HHmmss')}.png`

                link.click();
            });
        }

    };

    // Function to handle dynamic color based on the group
    const handleColor = (payload) => {
        // Return the dynamically updated `color` prop directly
        return currentColor?.[payload.group] || currentColor['default']; // Default color if group-specific color is not found
    };

    // Watch for changes in the `color` prop and update local state
    useEffect(() => {
        setCurrentColor(color);
    }, [color]);


    useEffect(() => {
        if (!data || data.length === 0) return; // ป้องกัน error กรณี data ว่าง

        // คำนวณผลรวมของแต่ละปี
        const totalPerYear = data.reduce((acc, { year, value }) => {
            acc[year] = (acc[year] || 0) + value;
            return acc;
        }, {});

        // คำนวณเปอร์เซ็นต์
        const percentData = data.map((item) => ({
            ...item,
            percent: parseFloat(((item.value / totalPerYear[item.year]) * 100).toFixed(2)), // คงค่าเป็น number
        }));

        setCurrentData(percentData);
    }, [data]);


    useEffect(() => {

        if (fileExport === 'EXCEL') {
            handleOpenSubmit(true)
            setTypeSubmit(title)
        } else if (fileExport === 'PNG') {
            handleOpenSubmit(true)
            setTypeSubmit(title)
        }

    }, [fileExport])


    const findPercentCurrent = (item) => {
        let findPercent = currentData.find(d => d.year === item.year && d.group === item.group)

        return findPercent.percent
    }

    const findTooltip = (item) => {
        let findCurrent = currentData.find(d => d.year === item.year && d.group === item.group)
        let value = `${item.group}  ${comma(findCurrent.value)} คน ${findCurrent?.percent ? `(${findCurrent?.percent}) %` : ''}`
        return value
    }

    return (
        <>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', flex: 1 }}>
                <Box sx={{ width: '50%' }}>
                    <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                        {title}
                    </Typography>
                </Box>

                <Box sx={{ width: '50%', position: 'relative' }}>

                    {export_file && export_file.length > 0 ? <>
                        <Select
                            size="small"
                            value={fileExport || "null"}
                            onChange={(e) => { setFileExport(e.target.value); }}
                            sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                backgroundColor: '#C8EBEB',
                                border: 'none',
                                zIndex: 10,
                                '.MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#C8EBEB',
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#C8EBEB',
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#C8EBEB',
                                },
                            }}
                        >
                            <MenuItem value="null" disabled>
                                Export
                            </MenuItem>
                            {export_file.map((i, idx) => (
                                <MenuItem key={idx} value={i}>{i}</MenuItem>
                            ))}
                        </Select>
                    </> : null}


                </Box>

                <Box sx={{ width: '100%', pt: 3 }}>

                    {color ? <Box ref={chartRef}><StackedColumnChart
                        data={currentData} // Use the latest `data` prop directly
                        autoFit
                        padding="auto"
                        xField="year"
                        yField="percent"
                        stackField="group"
                        color={handleColor} // Pass the dynamic color function
                        minColumnWidth={50}
                        maxColumnWidth={50}

                        yAxis={{
                            max: 100,
                            label: {
                                formatter: (v) => `${comma(v)}`,
                                style: {
                                    fontSize: 12,
                                    fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                    fill: "#333",
                                    fontWeight: "bold",
                                },
                            },
                        }}
                        xAxis={{
                            label: {
                                style: {
                                    fontSize: 12,
                                    fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                    fill: "#333",
                                    fontWeight: "bold",
                                },
                            },
                        }}
                        label={{
                            position: 'middle', // Positions the label inside the column
                            style: {
                                fill: '#000', // White text for better contrast inside the column
                                fontSize: 10,
                                fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                fontWeight: "bold",
                            },
                            formatter: (datum) => {

                                return `${comma(datum.value)} (${findPercentCurrent(datum)}%)`
                            }

                        }}

                        tooltip={{
                            showTitle: false,
                            formatter: (item) => {

                                return ({
                                    value: findTooltip(item),

                                })
                            },
                            domStyles: {
                                'g2-tooltip': {
                                    fontSize: '12px',
                                    fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                    color: "#333",
                                    fontWeight: "bold",
                                    textAlign: 'left', // Align text to the left
                                },
                                'g2-tooltip-content': {
                                    textAlign: 'right', // Ensure the content aligns left
                                }
                            },
                        }}
                        legend={{
                            position: "bottom",
                            itemName: {
                                style: {
                                    fontSize: 12,
                                    fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                    fill: "#333",
                                    fontWeight: "bold",
                                },
                            },
                        }}
                    />
                    </Box>
                        : null}

                </Box>

                <DialogSubmit
                    title={`${typeSubmit}`}
                    fileType={fileExport}
                    open={openSubmit}
                    setOpen={setOpenSubmit}
                    handleOpenSubmit={handleOpenSubmit}
                />
            </Box>
        </>
    );
}

export default ChartCustom;
